import React, { useEffect } from "react";
import { Interweave } from "interweave";
import { Paragraph } from "Components/CommonComponents/GeneralComponents";
import PropTypes from "prop-types";
const regex = /[+\-*/=<>^%]/;
const MathRenderer = (props) => {
  const { mathml } = props;

  useEffect(() => {
    // Trigger MathJax rendering when component mounts
    if (window.MathJax) {
      window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
    }
  }, [mathml]);

  return (
    <div className="math-renderer">
      <div dangerouslySetInnerHTML={{ __html: mathml }} />
    </div>
  );
};

MathRenderer.propTypes = {
  mathml: PropTypes.any,
};
const QuestionTextProvider = ({ content }) => {
  return (
    <div className="w-100 text-start text-dark">
      {content &&
      content !== undefined &&
      content !== null &&
      content.includes("<math") ? (
        // <MathjaxProvider html={content} />
        <MathRenderer mathml={content} />
      ) : content !== undefined &&
        content !== null &&
        content.includes("</") &&
        !content.includes("<html>") &&
        !regex.test(content) ? (
        <Interweave className="marginBottomAIHINT" content={content} />
      ) : content !== undefined &&
        content !== null &&
        content.includes("<html>") ? (
        <iframe srcDoc={content} title="my-iframe"></iframe>
      ) : content !== undefined && content !== null && regex.test(content) ? (
        <MathRenderer mathml={content} />
      ) : content !== undefined && content !== null ? (
        <Paragraph className="marginBottomAIHINT">{content}</Paragraph>
      ) : null}
    </div>
  );
};
QuestionTextProvider.propTypes = {
  content: PropTypes.any,
};
export default QuestionTextProvider;
